import React, {Component} from 'react';
import * as util from '../../../utils/util';
import Api from '../../../utils/api';
import { productTypeUpdated, RESPONSE_STATUS } from '../../../utils/constants';
import Responsive from 'react-responsive';
import {NavLink, withRouter} from 'react-router-dom';

class planGatePay extends Component {
  constructor(props) {
      super(props);
      this.state = {}
  }

  
// PLAN_ONE: 10
// PLAN_WTO: 10
// PLAN_THREE: 65
// 
  handleAccessNow(value){
    var planTypeValue = 5;  //  默认值
    var planMoney = 10;     //  默认值

    if(value == "PLAN_ONE"){
        planTypeValue = 5;
        planMoney = 10;
    }else if(value == "PLAN_WTO"){
        planTypeValue = 2;
        planMoney = 10;
    }else if(value == "PLAN_THREE"){
        planTypeValue = 3;
        planMoney = 65;
    }

    if(value == "PLAN_ONE"){
        this.gtag_report_conversion_Free()
    }else if(value == "PLAN_WTO"){
        this.gtag_report_conversion_Expert();
    }else if(value == "PLAN_THREE"){
        this.gtag_report_conversion_Luxe();
    }

    this.saveBudget(planTypeValue).then(()=>{
        if(value == "PLAN_ONE"){
            this.props.history.push({pathname :"/recommendation-landing",state:{ planValue: planMoney,paymentType: value} })
        }else{
            this.props.history.push({pathname :"/recommendation-landing",state:{planValue:planMoney,paymentType: value}});
        }
    }, (err) => {
        console.log(err)
    })
  }

  saveBudget = async(planTypeValue) => {
    const userId = localStorage.getItem("user_id");
    const url = "/api/user-profiles";

    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'PATCH',
            headers: {
                'x-auth-token': Api.auth_tokenManager(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                userId: userId,
                tier: planTypeValue
            })
        }).then(response => {
            if (response.status === 200) {
                if(planTypeValue == 1){
                    this.saveGateFeeAmount().then(()=>{
                          resolve('resolve return');
                    }).catch(err => resolve(err))
                }else{
                  resolve('resolve return');
                }
                localStorage.setItem("planTier",planTypeValue);
            } else {
                alert("There was a problem saving your budget preferences. Please try again.");
                reject('reject return');
            }
        });
    })
  }

  saveGateFeeAmount() {
    return new Promise((resolve, reject) => {
        const url = '/api/gate-fees';
        const userId = localStorage.getItem("user_id");
        var timestamp = Math.round(new Date() / 1000);
        var timestampValue = util.convertToStandardTime(timestamp)
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            },
            body: JSON.stringify({
                "userId": userId,
                "amount": 0.00,
                "timestamp": timestampValue
            })
        })
        .then(response => {
            if (response.status === RESPONSE_STATUS.OK || (response.status >= 200 && response.status < 300)) {
                resolve("resolve return");
            } else {
                reject("reject return");
            }
        })
        .catch(err => {
            reject("reject return");
            console.log('There was a problem saving your  consultation fee payment: ' + err);
        });
    })
  }
  //  Free plan button click
  gtag_report_conversion_Free(url) {
    var callback = function () {
      if (typeof(url) != 'undefined') {
        window.location = url;
      }
    };
    if(window.gtag)
    window.gtag('event', 'conversion', {
        'send_to': 'AW-714364604/WBCPCKfbrfcBELyt0dQC',
        'transaction_id': '',
        'event_callback': callback
    });
    return false;
  }

  //Expert plan button click
  gtag_report_conversion_Expert(url) {
    var callback = function () {
      if (typeof(url) != 'undefined') {
        window.location = url;
      }
    };
    if(window.gtag)
    window.gtag('event', 'conversion', {
        'send_to': 'AW-714364604/0WI_CI7drfcBELyt0dQC',
        'transaction_id': '',
        'event_callback': callback
    });
    return false;
  }

  //Luxe plan button click
  gtag_report_conversion_Luxe(url) {
    var callback = function () {
      if (typeof(url) != 'undefined') {
        window.location = url;
      }
    };
    if(window.gtag)
    window.gtag('event', 'conversion', {
        'send_to': 'AW-714364604/yodICM-6t_cBELyt0dQC',
        'transaction_id': '',
        'event_callback': callback
    });
    return false;
  }


  render() {
    return (
      <div className="ally-achiever-area">
          <div className="are-zone">
              <div className="select-plan-title fo-blod">EXPLORER</div>
              <div className="select-plan-money fo-blod">$10</div>
              <div className="select-plan-money-explain h5-title">One time charge, not a subscription</div>
              <button className="p-a-n-button" onClick={()=>{this.handleAccessNow('PLAN_ONE')}}>Access Now</button>
              <div>
                  <ul className="ul-plan-info">
                      <li>
                          <i className="icon-p-personalized"></i>
                          <div>
                              <div className="ul-plan-info-item-text">
                                  <i className="fa fa-circle icon-fa-circle "></i>
                                  <div><span className="fo-blod">Fully personalized </span> product recommendations</div>
                              </div>
                          </div>
                      
                      </li>

                      <li>
                          <i className="icon-p-purchases"></i>
                          <div>
                              <div className="ul-plan-info-item-text">
                                      <i className="fa fa-circle icon-fa-circle "></i>
                                      <div> <span className="fo-blod"> $10 to spend</span> (making this  <span className="fo-blod">FREE</span>) and <span className="fo-blod">15% off</span> on your first order</div>
                              </div>
                          </div>
                      </li>
                  </ul>
              </div>
              <div className="text-pop-a" onClick={()=>{  this.props.handleOpenModesGuarantee() }}>7-Day money back guarantee</div>
          </div>

          <div className="are-zone bor-red mostpop-achiever">
              <div className="select-plan-title fo-blod">EXPERT</div>
              <div className="select-plan-money fo-blod"> 
                <span className="select-plan-money-real">$10</span>
                <span className="select-plan-money-selling orange">$20 <i className="money-selling-solid"/> </span> 
              </div>
              <div className="select-plan-money-explain h5-title">One time charge, not a subscription</div>
              <button className="p-a-n-button" onClick={()=>{this.handleAccessNow('PLAN_WTO')}}>Access Now</button>
              
              <div className="right-top-tag-most">
                  <img src="../images/plan/mostPopular.png"></img>
              </div>
              
              <div>
                  <ul className="ul-plan-info">
                        <li>
                          <i className="icon-p-service"></i>
                          <div>
                                <div className="ul-plan-info-item-text">
                                    <i className="fa fa-circle icon-fa-circle "></i>
                                    <div>A  <span className="fo-blod">15-min 1-on-1 virtual consult </span> with a licensed skin expert</div>
                                </div>
                                <div className="ul-plan-info-item-text">
                                    <i className="fa fa-circle icon-fa-circle "></i>
                                    <div>
                                        <span className="fo-blod">Text your skin expert </span>
                                        anytime for questions
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li>
                            <i className="icon-p-personalized"></i>
                            <div>
                              <div className="ul-plan-info-item-text">
                                  <i className="fa fa-circle icon-fa-circle "></i>
                                  <div><span className="fo-blod">Fully personalized</span> product recommendations</div>
                              </div>
                            </div>
                        </li>

                        <li >
                          <i className="icon-p-purchases"></i>
                          <div>
                              <div className="ul-plan-info-item-text">
                                  <i className="fa fa-circle icon-fa-circle "></i>
                                  <div>
                                      <span className="fo-blod">$10 to spend</span> and <span className="fo-blod">15% off</span> on your first order   
                                  </div>
                                  
                              </div>
                              <div className="ul-plan-info-item-text">
                                  <i className="fa fa-circle icon-fa-circle "></i>
                                  <div>
                                      <span className="fo-blod">10% off </span> all future purchases
                                  </div>
                              </div>
                          </div>
                        </li>
                      
                  </ul>
              </div>
              <div className="text-pop-a" onClick={()=>{  this.props.handleOpenModesGuarantee() }}>7-Day money back guarantee</div>
          </div>

          <div className="are-zone mostpop-achiever">
              <div className="select-plan-title fo-blod">LUXE</div>
              <div className="select-plan-money fo-blod">$65</div>
              <div className="select-plan-money-explain h5-title">One time charge, not a subscription</div>
              <button className="p-a-n-button" onClick={()=>{this.handleAccessNow('PLAN_THREE')}}>Access Now</button>
              <div>
                  <ul className="ul-plan-info">
                        <li>
                          <i className="icon-p-service"></i>
                          <div>
                              <div className="ul-plan-info-item-text">
                                  <i className="fa fa-circle icon-fa-circle "></i>
                                  <div>
                                      <span className="fo-blod">A 30-min 1-on-1 virtual consult </span> 
                                      with Ava’s lead skin expert
                                  </div>
                              </div>
                              <div className="ul-plan-info-item-text">
                                  <i className="fa fa-circle icon-fa-circle "></i>
                                  <div>
                                      <span className="fo-blod">3 follow up consults</span> to track progress
                                  </div>
                              </div>
                              <div className="ul-plan-info-item-text">
                                  <i className="fa fa-circle icon-fa-circle "></i>
                                  <div>
                                      <span className="fo-blod">Text your skin expert </span>
                                      anytime for questions
                                  </div>
                              </div>
                          </div>
                        </li>

                        <li>
                            <i className="icon-p-personalized"></i>
                            <div>
                                <div className="ul-plan-info-item-text">
                                    <i className="fa fa-circle icon-fa-circle "></i>
                                    <div><span className="fo-blod">Fully personalized</span> product recommendations</div>
                                </div>
                            </div>
                        </li>
                        
                        <li>
                            <i className="icon-p-purchases"></i>
                            <div>
                                <div className="ul-plan-info-item-text">
                                    <i className="fa fa-circle icon-fa-circle "></i>
                                    <div>
                                        <span className="fo-blod">$20 to spend </span> and <span className="fo-blod">15% off</span> on your first order 
                                    </div>
                                </div>
                                <div className="ul-plan-info-item-text">
                                    <i className="fa fa-circle icon-fa-circle "></i>
                                    <div> <span className="fo-blod">10% off</span> all future purchases</div>
                                </div>

                                <div className="ul-plan-info-item-text">
                                    <i className="fa fa-circle icon-fa-circle "></i>
                                    <div> <span className="fo-blod">Early access</span> to all sales </div>
                                </div>
                            </div>
                        </li>
                  </ul>
              </div>
              <div className="text-pop-a" onClick={()=>{  this.props.handleOpenModesGuarantee() }}>7-Day money back guarantee</div>
          </div>
      </div>
    )
  } 
}      

export default withRouter(planGatePay);


// WEBPACK FOOTER //
// ./src/views/AA/plan/planGatePay.js